import screenerAPI from 'media-base-ui/utils/screenerAPI';
import actionCreators from './actionCreators';

const fetchScreenersData = () => async dispatch => {
    dispatch(actionCreators.requestScreeners());

    try {
        const data = await screenerAPI.fetchScreenersData();
        const dataWithMetadata = await fetchMetadata(data.data);

        dispatch(actionCreators.screenersResponse(true, dataWithMetadata, []));
    } catch (error) {
        dispatch(actionCreators.screenersResponse(false, [], error));
    }
};

const fetchScreenerData = (id) => async dispatch => {
    dispatch(actionCreators.requestScreener());

    try {
        const data = await screenerAPI.fetchScreenerData(id);
        const dataWithMetadata = await fetchMetadata(data.data);

        dispatch(actionCreators.screenersResponse(true, dataWithMetadata, []));
    } catch (error) {
        dispatch(actionCreators.screenersResponse(false, [], error));
    }
};

const fetchMetadata = async (screeners) => {
    for (const screener of screeners) {
        try {
            if (screener.vimeoVideoUrl !== null) {
                const metadata = await fetchSingleMetadata(screener.vimeoVideoUrl);
                screener.vimeoThumbnail = metadata.thumbnail_url;
                screener.html = metadata.html;
            }
        } catch (e) {
            screener.error = e;
        }
    }
    return screeners;
};

const fetchSingleMetadata = async (videoUrl) => {
    return await screenerAPI.fetchScreenerMetadata(videoUrl);
};

export default {
    fetchScreenersData,
    fetchScreenerData,
};
